function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M54.6643 108.502C84.4867 108.502 108.663 84.3265 108.663 54.5041C108.663 24.6817 84.4867 0.505859 54.6643 0.505859C24.8419 0.505859 0.666016 24.6817 0.666016 54.5041C0.666016 84.3265 24.8419 108.502 54.6643 108.502Z",
    fill: "#E4F2E6",
    style: {
      fill: "#E4F2E6",
      fill: "color(display-p3 0.8941 0.9490 0.9020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7656 57.2053L46.5653 68.005L73.5644 41.0059",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 8.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/successCheck.c3c2f3b8d280ffb3a2d0e18067d149d7.svg";
export { ForwardRef as ReactComponent };